import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function animFunction() {
	if(!$(".wp-block-thefuturblocks-scroll-anim").length) {
		return;
	}
	$(".wp-block-thefuturblocks-scroll-anim").each(function() {
		var self = $(this),
			holder = self.find(".wp-block-thefuturblocks-scroll-anim__holder"),
			inner = self.find(".wp-block-thefuturblocks-scroll-anim__inner");

		let tl, startA;
		if(self.hasClass("anim-fade-in")) {
			tl = gsap.fromTo(self,{autoAlpha:0},{duration:0.6,autoAlpha:1});
		} else if(self.hasClass("anim-reveal-l")) {
			gsap.set(self,{autoAlpha:1});
			tl = gsap.timeline({paused:true})
		    .fromTo(self, {xPercent:-100},{duration:0.8,xPercent:0})
		    .fromTo(inner, {xPercent:100},{duration:0.8,xPercent:0}, "<");
		} else if(self.hasClass("anim-reveal-t")) {
			gsap.set(self,{autoAlpha:1});
			tl = gsap.timeline({paused:true})
		    .fromTo(holder, {yPercent:100},{duration:0.6,yPercent:0})
		    .fromTo(inner, {yPercent:-100},{duration:0.6,yPercent:0}, "<");
		} else if(self.hasClass("anim-fade-up-sk")) {
			tl = gsap.fromTo(self,{y:30,autoAlpha:0, skewY:-5},{duration:0.6,y:0,autoAlpha:1,skewY:0});
		} else if(self.hasClass("anim-fade-down")) {
			tl = gsap.fromTo(self,{y:-30,autoAlpha:0},{duration:0.6,y:0,autoAlpha:1});
		} else if(self.hasClass("anim-fade-up")) {
			tl = gsap.fromTo(self,{y:30,autoAlpha:0},{duration:0.6,y:0,autoAlpha:1});
		}
		var st = ScrollTrigger.create({
			trigger: self,
			start: "+=180 bottom",
			// markers: {startColor: "blue", endColor: "yellow", indent: 100},
			//toggleActions: "play reverse play reverse",
			animation: tl
		});
	});
}

$(window).on('load', () => {
  if($('.c-loader').length) {
		gsap.delayedCall(4, function() {
			animFunction();
		})
	} else {
		gsap.delayedCall(0.4, function() {
			animFunction();
		})
	}
})